<template>
  <div>
    <keep-alive>
      <component :is="currentComponent" :payment="paymentMethod" />
    </keep-alive>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import cardDefault from './defaults/CardDefault.vue';
import paypalDefault from './defaults/PaypalDefault.vue';

export default {
  props: ['lesson'],

  components: {
    cardDefault,
    paypalDefault,
  },

  computed: {
    ...mapGetters({
      student: 'auth/student',
    }),

    currentComponent() {
      return `${this.lesson.payment_method}Default`;
    },

    paymentMethod() {
      if (this.lesson.payment_method === 'paypal') {
        return {
          name: 'Paypal',
          type: 'paypal',
        };
      }
      return {
        name: 'Credit Card',
        type: 'card',
        card_last_four: this.lesson.card_last_four,
        card_brand: this.lesson.card_brand,
      };
    },
  },
};
</script>
